import { SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { SERVER_API_URL } from 'app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage/dist/services/sessionStorage";
import * as i2 from "@angular/common/http";
var AccountService = /** @class */ (function () {
    function AccountService(sessionStorage, http) {
        this.sessionStorage = sessionStorage;
        this.http = http;
        this.authenticated = false;
        this.authenticationState = new Subject();
        this.userAccountState = new Subject();
    }
    AccountService.prototype.fetch = function () {
        return this.http.get(SERVER_API_URL + 'api/account', { observe: 'response' });
    };
    AccountService.prototype.fetchAccount = function () {
        return this.http.get(SERVER_API_URL + 'api/sentinel-accounts/' + this.userIdentity.email, { observe: 'response' });
    };
    AccountService.prototype.save = function (account) {
        return this.http.post(SERVER_API_URL + 'api/account', account, { observe: 'response' });
    };
    AccountService.prototype.authenticate = function (identity) {
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
        if (identity == null || identity == undefined) {
            this.userAccount = null;
        }
    };
    AccountService.prototype.hasAnyAuthority = function (authorities) {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return false;
        }
        for (var i = 0; i < authorities.length; i++) {
            if (this.userIdentity.authorities.includes(authorities[i])) {
                return true;
            }
        }
        return false;
    };
    AccountService.prototype.hasAuthority = function (authority) {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }
        return this.identity().then(function (id) {
            return Promise.resolve(id.authorities && id.authorities.includes(authority));
        }, function () {
            return Promise.resolve(false);
        });
    };
    AccountService.prototype.identity = function (force) {
        var _this = this;
        if (force) {
            this.userIdentity = undefined;
        }
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.fetch()
            .toPromise()
            .then(function (response) {
            var account = response.body;
            if (account) {
                _this.userIdentity = account;
                _this.authenticated = true;
            }
            else {
                _this.userIdentity = null;
                _this.authenticated = false;
            }
            _this.authenticationState.next(_this.userIdentity);
            return _this.userIdentity;
        })
            .catch(function (err) {
            _this.userIdentity = null;
            _this.authenticated = false;
            _this.authenticationState.next(_this.userIdentity);
            return null;
        });
    };
    AccountService.prototype.userAccountIdentity = function (force) {
        var _this = this;
        if (force) {
            this.userAccount = undefined;
        }
        // check and see if we have retrieved the userAccount data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userAccount) {
            return Promise.resolve(this.userAccount);
        }
        // retrieve the userAccount data from the server, update the identity object, and then resolve.
        return this.fetchAccount()
            .toPromise()
            .then(function (response) {
            var account = response.body;
            if (account) {
                _this.userAccount = account;
            }
            else {
                _this.userAccount = null;
            }
            _this.userAccountState.next(_this.userAccount);
            return _this.userAccount;
        })
            .catch(function (err) {
            _this.userAccount = null;
            _this.userAccountState.next(_this.userAccount);
            return null;
        });
    };
    AccountService.prototype.isAuthenticated = function () {
        return this.authenticated;
    };
    AccountService.prototype.isIdentityResolved = function () {
        return this.userIdentity !== undefined;
    };
    AccountService.prototype.getAuthenticationState = function () {
        return this.authenticationState.asObservable();
    };
    AccountService.prototype.getImageUrl = function () {
        return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
    };
    AccountService.ngInjectableDef = i0.defineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.inject(i1.SessionStorageService), i0.inject(i2.HttpClient)); }, token: AccountService, providedIn: "root" });
    return AccountService;
}());
export { AccountService };
